import React from 'react';

export function OutputArea({ message }: { message: string | null }) {
    return (
        <div className="flex-grow overflow-auto p-4">
            {message ? (
                <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
                    <div className="flex items-center gap-2 mb-3">
                        <div className="w-2 h-2 bg-indigo-500 rounded-full animate-pulse" />
                        <div className="font-small text-sm text-slate-600">CAi Response</div>
                    </div>
                    <div className="text-sm text-slate-700 whitespace-pre-wrap">
                        {typeof message === 'string' ? message.replace(/```markdown\s*/g, '```') : ''}
                    </div>
                </div>
            ) : (
                <div className="h-full flex items-center justify-center">
                    <p className="text-slate-400 text-sm">Your assistant is ready to help</p>
                </div>
            )}
        </div>
    );
}